import React from 'react';

const Hero = () => {
  return (
    <div id="home" className="relative pt-20 pb-32 flex content-center items-center justify-center min-h-screen bg-black overflow-hidden">
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source src="/promo.mp4" type="video/mp4" />
      </video>
      {/* Overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-zinc-900 opacity-70"></div>
      <div className="container relative mx-auto px-4 text-center z-10">
        <h2 className="text-gold font-semibold tracking-widest uppercase mb-4">We Create, You Celebrate</h2>
        <h1 className="text-white font-bold text-5xl md:text-7xl mb-6 font-serif">
          Exceptional Event <br/> <span className="text-gold">Planning & Design</span>
        </h1>
        <p className="mt-4 text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-10">
          Transforming your vision into an unforgettable reality. We specialize in luxury weddings, corporate galas, and exclusive private parties.
        </p>
        <a href="#services" className="bg-gold text-black font-bold px-8 py-4 uppercase tracking-wider hover:bg-white transition duration-300 border border-gold hover:border-white">
          Discover Our Services
        </a>
      </div>
    </div>
  );
};

export default Hero;